/* ============================================================
   Think4Earth custom scripts (see CUSTOM-CODE-REGISTER.md)
   Moved out of layout/theme.liquid 22 Jul 2026 so browsers cache
   this once instead of re-downloading it inside every page.
   Blocks: cart-drawer AJAX remove / main page tweaks /
   wholesale form styling / FAQ auto-close / AOV bundle enhancer
   ============================================================ */

/* ---- Block 0: fetch response normaliser (app-conflict guard) ----
   Fast Bundle (and other cart apps) monkey-patch window.fetch. One wrapper
   returns responses whose .json()/.text() don't return real Promises, which
   crashes the Section Store cart drawer ("t.json().catch is not a function")
   and blocks bundle add-to-cart. After all app scripts have loaded, wrap the
   final fetch chain once so json()/text() always return real Promises. */
(function () {
  function install() {
    var inner = window.fetch;
    if (!inner) return;
    var outer = function () {
      var p;
      try { p = inner.apply(window, arguments); } catch (e) { return Promise.reject(e); }
      return Promise.resolve(p).then(function (r) {
        if (r && typeof r.json === 'function') {
          var oj = r.json.bind(r);
          r.json = function () { try { return Promise.resolve(oj()); } catch (e) { return Promise.reject(e); } };
        }
        if (r && typeof r.text === 'function') {
          var ot = r.text.bind(r);
          r.text = function () { try { return Promise.resolve(ot()); } catch (e) { return Promise.reject(e); } };
        }
        return r;
      });
    };
    window.fetch = outer;
  }
  if (document.readyState === 'complete') {
    setTimeout(install, 300);
  } else {
    window.addEventListener('load', function () { setTimeout(install, 300); });
  }
})();

/* ---- Block 2: cart drawer AJAX remove ---- */
(function() {
  document.addEventListener('click', function(e) {
    if (e.target.closest('#CartDrawer .cart__remove a')) e.preventDefault();
  }, true);

  function doRemove(originalHref, cartItemEl) {
    var params = new URLSearchParams(new URL(originalHref, window.location.origin).search);
    var id = params.get('id');
    if (!id) return;
    if (cartItemEl) cartItemEl.style.opacity = '0.3';
    fetch('/cart/change.js?id=' + encodeURIComponent(id) + '&quantity=0')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        document.querySelectorAll('.cart-link__bubble-num').forEach(function(el) {
          el.textContent = cart.item_count;
        });
        if (cartItemEl) cartItemEl.remove();
      });
  }

  function wireRemoveButtons() {
    document.querySelectorAll('#CartDrawer .cart__remove a:not([data-t4e-wired])').forEach(function(link) {
      link.setAttribute('data-t4e-wired', '1');
      var originalHref = link.href;
      link.href = 'javascript:void(0)';
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var cartItem = link.closest('.cart__item') ||
                       link.closest('[class*="cart-item"]') ||
                       link.parentElement.parentElement;
        doRemove(originalHref, cartItem);
      });
    });
  }

  var cartDrawer = document.getElementById('CartDrawer');
  if (cartDrawer) {
    new MutationObserver(wireRemoveButtons).observe(cartDrawer, { childList: true, subtree: true });
  }
  wireRemoveButtons();
})();

/* ---- Block 2b: strip ".00" from whole-dollar prices, site-wide ----
   Text-node based so it never breaks event listeners; observer-driven so it
   catches dynamically rendered content; and shadow-DOM-aware so it reaches
   the Section Store cart drawer (custom element with an open shadow root).
   $20.00 -> $20, but $20.50 stays $20.50. JS on purpose: Shopify's
   no-decimals money format ROUNDS non-whole prices. */
(function () {
  var TEST_RE = /\$\s?[\d,]+\.00(?!\d)/;
  var REPLACE_RE = /(\$\s?[\d,]+)\.00(?!\d)/g;
  var observedRoots = new WeakSet();
  var mo = new MutationObserver(run);
  function stripTree(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        var p = n.parentNode && n.parentNode.nodeName;
        if (p === 'SCRIPT' || p === 'STYLE' || p === 'TEXTAREA' || p === 'NOSCRIPT') return NodeFilter.FILTER_REJECT;
        return TEST_RE.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (n) { n.nodeValue = n.nodeValue.replace(REPLACE_RE, '$1'); });
    root.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot) {
        if (!observedRoots.has(el.shadowRoot)) {
          observedRoots.add(el.shadowRoot);
          mo.observe(el.shadowRoot, { childList: true, subtree: true, characterData: true });
        }
        stripTree(el.shadowRoot);
      }
    });
  }
  var t;
  function run() { clearTimeout(t); t = setTimeout(function () { if (document.body) stripTree(document.body); }, 150); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  mo.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();

/* ---- Block 3: main page tweaks ---- */
document.addEventListener('DOMContentLoaded', function() {

  // Stars above title
  document.querySelectorAll('.product-section').forEach(function(section) {
    var stars = section.querySelector('.shopify-app-block');
    var header = section.querySelector('.product-block--header');
    if (stars && header) header.insertBefore(stars, header.firstChild);
  });

  // Hide dispatch sales point when product is out of stock
  var dispatchPoint = Array.from(document.querySelectorAll('.product-block--sales-point')).find(function(el) {
    return el.innerText.includes('12pm') || el.innerText.includes('dispatch');
  });
  if (dispatchPoint) {
    var productPath = window.location.pathname.replace(/\?.*/, '');
    var match = productPath.match(/\/products\/[^\/]+/);
    if (match) {
      fetch(match[0] + '.js')
        .then(function(r) { return r.json(); })
        .then(function(product) {
          if (!product.available) dispatchPoint.style.display = 'none';
        });
    }
  }

  var isProductPage = window.location.pathname.indexOf('/products/') !== -1;

  // Hide price on bread bag & baguette bag pages (price shown in bundle widget)
  var isBreadOrBaguette = (window.location.pathname.includes('bread-bag') || window.location.pathname.includes('baguette-bag')) && !window.location.pathname.includes('cotton') && !window.location.pathname.includes('beeswax');
  if (isBreadOrBaguette) {
    var priceBlock = document.querySelector('.product-block--price');
    if (priceBlock) priceBlock.style.display = 'none';
  }

  // Orange underline under "Bundle and Save" heading (product pages only)
  if (isProductPage) {
    var bundleUnderlineAdded = false;
    var addBundleUnderline = function() {
      if (bundleUnderlineAdded) return;
      var bundleTitle = document.querySelector('.bundle-title');
      if (bundleTitle) {
        bundleUnderlineAdded = true;
        bundleTitle.style.position = 'relative';
        bundleTitle.style.paddingBottom = '18px';
        var ul = document.createElement('div');
        ul.style.cssText = 'position:absolute;bottom:0;left:50%;transform:translateX(-50%);width:110px;height:4px;background:#F27B26;border-radius:2px;';
        bundleTitle.appendChild(ul);
      }
    };
    addBundleUnderline();
    var bundleObserver = new MutationObserver(function() {
      if (!bundleUnderlineAdded) addBundleUnderline();
      else bundleObserver.disconnect();
    });
    bundleObserver.observe(document.body, { childList: true, subtree: true });
  }

  // Feature icons — bread bag & baguette bag pages
  if (isBreadOrBaguette) {
    var featureItems = [
      { icon: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10z"/><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/></svg>', text: 'Keeps Bread Fresh Longer' },
      { icon: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="20" rx="3"/><circle cx="12" cy="13" r="4.5"/><path d="M5 6h3"/></svg>', text: 'Machine Washable' },
      { icon: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="2" x2="12" y2="22"/><line x1="2" y1="12" x2="22" y2="12"/><polyline points="9 5 12 2 15 5"/><polyline points="9 19 12 22 15 19"/><polyline points="5 9 2 12 5 15"/><polyline points="19 9 22 12 19 15"/></svg>', text: 'Bench, Fridge & Freezer Safe' },
      { icon: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"/></svg>', text: 'Stops Freezer Burn' },
      { icon: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 10 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"/></svg>', text: 'Breathable — Prevents Mould Growth*' },
      { icon: '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/></svg>', text: 'Made from Recycled Bottles' }
    ];
    var featHtml = '<div class="t4e-features">' + featureItems.map(function(f) {
      return '<div class="t4e-feature">' + f.icon + '<span>' + f.text + '</span></div>';
    }).join('') + '</div>';
    var descBlock = null;
    document.querySelectorAll('.product-single__meta .product-block').forEach(function(block) {
      if (block.innerText && (block.innerText.includes('150,000') || block.innerText.includes('Keep bread') || block.innerText.includes('Thoughtfully'))) {
        descBlock = block;
      }
    });
    if (descBlock) {
      descBlock.insertAdjacentHTML('afterend', featHtml);
    } else {
      var priceEl = document.querySelector('.product__price');
      if (priceEl) priceEl.insertAdjacentHTML('afterend', featHtml);
    }
  }

  // Mobile nav drawer — announcement bar fix, ✕ icon, scroll lock, Shop sub-panel
  (function() {
    var hamburger = document.querySelector('.js-drawer-open-nav');
    var navDrawer  = document.getElementById('NavDrawer') || document.querySelector('.drawer--right');
    var header    = document.querySelector('.site-header');
    if (!hamburger || !navDrawer) return;

    var xSpan = document.createElement('span');
    xSpan.style.cssText = 'display:none;font-size:22px;font-weight:300;color:#333;line-height:1;pointer-events:none;';
    hamburger.appendChild(xSpan);
    xSpan.textContent = '✕';
    var hamIcon = hamburger.querySelector('.icon-hamburger, svg');

    function preventTouch(e) {
      if (!e.target.closest('.drawer--right') && !e.target.closest('#t4e-sub-panel')) e.preventDefault();
    }

    var subPanel = null;
    var subPanelTop = 0;

    function buildSubPanel() {
      if (subPanel) return;
      var shopLink = null;
      navDrawer.querySelectorAll('.mobile-nav__link--top-level').forEach(function(el) {
        if (el.textContent.trim().toLowerCase() === 'shop') shopLink = el;
      });
      var parentItem = shopLink ? shopLink.closest('.mobile-nav__item--has-children, li') : null;
      var subList = parentItem ? parentItem.querySelector('ul, .mobile-nav__dropdown') : null;

      subPanel = document.createElement('div');
      subPanel.id = 't4e-sub-panel';
      subPanel.style.cssText = 'position:fixed;top:0;right:0;bottom:0;width:100%;max-width:320px;background:#fff;z-index:1000001;overflow-y:auto;-webkit-overflow-scrolling:touch;transition:transform 0.3s cubic-bezier(0.165,0.84,0.44,1);transform:translateX(110%);';

      var backBtn = document.createElement('button');
      backBtn.style.cssText = 'display:flex;align-items:center;gap:8px;width:100%;padding:16px 20px;border:none;background:none;font-size:15px;font-weight:600;color:#333;cursor:pointer;border-bottom:1px solid #eee;';
      backBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg> Shop';
      backBtn.addEventListener('click', closeSubPanel);
      subPanel.appendChild(backBtn);

      if (subList) {
        subList.querySelectorAll('a').forEach(function(a) {
          var item = document.createElement('a');
          item.href = a.href;
          item.textContent = a.textContent.trim();
          item.style.cssText = 'display:block;padding:14px 20px;font-size:15px;color:#333;text-decoration:none;border-bottom:1px solid #f0f0f0;';
          subPanel.appendChild(item);
        });
      }
      document.body.appendChild(subPanel);
    }

    function openSubPanel() {
      buildSubPanel();
      subPanel.style.top = subPanelTop + 'px';
      subPanel.style.transform = 'translateX(0)';
    }
    function closeSubPanel() {
      if (subPanel) subPanel.style.transform = 'translateX(110%)';
    }

    function wireShopTap() {
      navDrawer.querySelectorAll('.mobile-nav__item--has-children').forEach(function(item) {
        var topLink = item.querySelector('.mobile-nav__link--top-level');
        if (!topLink) return;
        var text = topLink.textContent.trim().toLowerCase();
        if (text !== 'shop' && !text.startsWith('shop')) return;
        var expander = item.querySelector('.mobile-nav__toggle, .mobile-nav__arrow, button');
        var trigger = expander || topLink;
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          openSubPanel();
        }, true);
      });
    }

    var overlaySelectors = '.site-overlay, .drawer-overlay, .page-overlay, #DrawerOverlay, .js-overlay, .drawer__overlay';
    var overlayObs = null;
    var overlayBottom = 0;
    function fixOverlay() {
      document.querySelectorAll(overlaySelectors).forEach(function(el) {
        el.style.setProperty('top', overlayBottom + 'px', 'important');
      });
    }
    function watchForOverlay() {
      if (overlayObs) return;
      overlayObs = new MutationObserver(fixOverlay);
      overlayObs.observe(document.body, { childList: true, subtree: false });
    }
    function unwatchOverlay() {
      if (overlayObs) { overlayObs.disconnect(); overlayObs = null; }
      document.querySelectorAll(overlaySelectors).forEach(function(el) { el.style.removeProperty('top'); });
    }

    function onOpen() {
      var annoBar = document.querySelector('.announcement-bar, .announcement-bar-section, [class*="announcement"]');
      var annoBottom = 0;
      if (annoBar) annoBottom = Math.max(0, annoBar.getBoundingClientRect().bottom);
      if (header) {
        var headerHeight = header.getBoundingClientRect().height;
        var drawerTop = annoBottom + headerHeight;
        header.style.setProperty('position', 'fixed', 'important');
        header.style.setProperty('top', annoBottom + 'px', 'important');
        header.style.setProperty('left', '0', 'important');
        header.style.setProperty('right', '0', 'important');
        header.style.setProperty('z-index', '999999', 'important');
        header.style.setProperty('background', '#fff', 'important');
        navDrawer.style.setProperty('top', drawerTop + 'px', 'important');
        overlayBottom = drawerTop;
        subPanelTop = drawerTop;
      }
      fixOverlay();
      watchForOverlay();
      if (hamIcon) hamIcon.style.display = 'none';
      xSpan.style.display = 'block';
      document.body.classList.add('t4e-nav-open');
      document.addEventListener('touchmove', preventTouch, { passive: false });
      wireShopTap();
    }

    function onClose() {
      if (header) {
        header.style.removeProperty('position');
        header.style.removeProperty('top');
        header.style.removeProperty('left');
        header.style.removeProperty('right');
        header.style.removeProperty('z-index');
        header.style.removeProperty('background');
      }
      navDrawer.style.removeProperty('top');
      unwatchOverlay();
      if (hamIcon) hamIcon.style.display = '';
      xSpan.style.display = 'none';
      document.body.classList.remove('t4e-nav-open');
      document.removeEventListener('touchmove', preventTouch);
      closeSubPanel();
    }

    new MutationObserver(function() {
      navDrawer.classList.contains('drawer--is-open') ? onOpen() : onClose();
    }).observe(navDrawer, { attributes: true, attributeFilter: ['class'] });

    hamburger.addEventListener('click', function(e) {
      if (navDrawer.classList.contains('drawer--is-open')) {
        e.stopImmediatePropagation();
        var closeBtn = document.querySelector('.drawer__close');
        if (closeBtn) closeBtn.click();
      }
    }, true);
  })();

  // Free shipping progress bar on cart page — updates live when quantities change.
  // Initial bar is server-rendered by snippets/t4e-free-shipping-bar.liquid;
  // this script only refreshes it after cart changes.
  if (window.location.pathname === '/cart') {
    (function() {
      var threshold = 14000; // $140 in cents — keep in sync with snippets/t4e-free-shipping-bar.liquid
      var debounceTimer;
      var busy = false;

      function buildBarHTML(totalCents) {
        var remaining = Math.max(0, threshold - totalCents);
        var pct = Math.min(100, Math.round((totalCents / threshold) * 100));
        var msg = remaining > 0
          ? 'You are <strong>$' + (remaining / 100).toFixed(2) + '</strong> away from free shipping.'
          : 'You\'ve unlocked <strong>free shipping!</strong> 🎉';
        return '<p style="font-size:13px;text-align:center;margin:0 0 8px;color:#333;">' + msg + '</p>' +
          '<div style="background:#e0e0e0;border-radius:4px;height:6px;overflow:hidden;">' +
            '<div style="background:#F27B26;height:100%;width:' + pct + '%;border-radius:4px;transition:width 0.4s;"></div>' +
          '</div>';
      }

      function insertOrUpdateBar(totalCents) {
        var existing = document.getElementById('t4e-cart-shipping-bar');
        if (existing) {
          busy = true;
          existing.innerHTML = buildBarHTML(totalCents);
          setTimeout(function() { busy = false; }, 150);
          return true;
        }
        var main = document.getElementById('MainContent') || document.querySelector('main');
        var btn = main && (
          main.querySelector('input[name="checkout"]') ||
          main.querySelector('button[name="checkout"]') ||
          main.querySelector('.cart__checkout') ||
          main.querySelector('[name="checkout"]')
        );
        if (!btn) return false;
        var bar = document.createElement('div');
        bar.id = 't4e-cart-shipping-bar';
        bar.style.cssText = 'padding:10px 0 14px;';
        bar.innerHTML = buildBarHTML(totalCents);
        btn.parentNode.insertBefore(bar, btn);
        return true;
      }

      function refresh() {
        fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          if (cart.item_count) insertOrUpdateBar(cart.total_price);
        });
      }

      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        if (!cart.item_count) return;
        var attempts = 0;
        var iv = setInterval(function() {
          if (insertOrUpdateBar(cart.total_price) || ++attempts >= 20) clearInterval(iv);
        }, 200);
      });

      var main = document.getElementById('MainContent') || document.querySelector('main');
      if (main) {
        new MutationObserver(function(mutations) {
          if (busy) return;
          var bar = document.getElementById('t4e-cart-shipping-bar');
          var selfChange = bar && mutations.every(function(m) {
            return bar === m.target || bar.contains(m.target);
          });
          if (!selfChange) {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(refresh, 500);
          }
        }).observe(main, { childList: true, characterData: true, subtree: true });
      }
    })();
  }

  // Orange Add buttons in bundle widget (product pages only, debounced)
  if (isProductPage) {
    var styleBundleTimer;
    var styleBundleAddBtns = function() {
      document.querySelectorAll('[class*="bundle"] button, [class*="Bundle"] button').forEach(function(btn) {
        var txt = btn.textContent.trim().toLowerCase();
        if (txt === 'add' || txt === 'added') {
          btn.style.setProperty('background', '#F27B26', 'important');
          btn.style.setProperty('color', '#fff', 'important');
          btn.style.setProperty('border-color', '#F27B26', 'important');
          btn.style.setProperty('border-radius', '4px', 'important');
        }
      });
    };
    styleBundleAddBtns();
    new MutationObserver(function() {
      clearTimeout(styleBundleTimer);
      styleBundleTimer = setTimeout(styleBundleAddBtns, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }

});

/* ---- Block 4: wholesale form styling ---- */
(function() {
  if (!window.location.pathname.includes('wholesale-registration')) return;
  function styleWholesaleForm() {
    var embed = document.querySelector('shopify-forms-embed');
    if (!embed || !embed.shadowRoot) return false;
    if (embed.shadowRoot.querySelector('#t4e-wholesale-style')) return true;
    var style = document.createElement('style');
    style.id = 't4e-wholesale-style';
    style.textContent =
      'h1,h2,h3{text-transform:uppercase!important}' +
      'h1:first-of-type,h2:first-of-type,h3:first-of-type{' +
        'position:relative!important;' +
        'padding-bottom:22px!important;' +
        'margin-bottom:24px!important' +
      '}' +
      'h1:first-of-type::after,h2:first-of-type::after,h3:first-of-type::after{' +
        'content:"";display:block;position:absolute;bottom:0;left:50%;' +
        'transform:translateX(-50%);width:110px;height:4px;' +
        'background:#F27B26;border-radius:2px' +
      '}' +
      'button[type="submit"]{' +
        'background:#F27B26!important;' +
        'border-color:#F27B26!important;' +
        'color:#fff!important' +
      '}';
    embed.shadowRoot.appendChild(style);
    return true;
  }
  if (!styleWholesaleForm()) {
    var obs = new MutationObserver(function() {
      if (styleWholesaleForm()) obs.disconnect();
    });
    obs.observe(document.body, {childList: true, subtree: true});
  }
})();

/* ---- Block 5: FAQ auto-close ---- */
(function () {
  function contentOf(t) {
    var id = t.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }
  function isOpen(t) {
    if (t.getAttribute('aria-expanded') === 'true') return true;
    if (t.classList.contains('is-open')) return true;
    var c = contentOf(t);
    return !!(c && c.offsetHeight > 5);
  }
  document.addEventListener('click', function (e) {
    if (!e.isTrusted) return;
    var trigger = e.target.closest('.faq-item .collapsible-trigger');
    if (!trigger) return;
    setTimeout(function () {
      if (!isOpen(trigger)) return;
      document.querySelectorAll('.faq-item .collapsible-trigger').forEach(function (other) {
        if (other !== trigger && isOpen(other)) other.click();
      });
    }, 60);
  });
})();

/* ---- Block 6: AOV.ai bundle widget enhancer ---- */
(function () {
  if (window.location.pathname.indexOf('/products/') === -1) return;
  var subs = {
    1: 'Try one now',
    2: 'One on the bench, one in the freezer',
    3: 'One on the bench, one in the freezer, one to gift'
  };
  // T4E: pre-select the 2-pack once per page load, unless the shopper
  // has already interacted with the widget.
  var preselected = false;
  var preselectTries = 0;
  var userTouched = false;
  document.addEventListener('pointerdown', function (ev) {
    var pth = ev.composedPath ? ev.composedPath() : [];
    for (var k = 0; k < pth.length; k++) {
      var n = pth[k];
      if (n && n.classList && (n.classList.contains('bundle-widget') || n.classList.contains('bundle-option'))) { userTouched = true; break; }
    }
  }, true);
  function money(el){ return el ? (parseFloat((el.textContent||'').replace(/[^0-9.]/g,''))||0) : 0; }
  function enhance() {
    var opts = document.querySelectorAll('.bundle-option');
    if (!opts.length) return;
    if (!preselected && !userTouched && opts.length > 1) {
      var activeIdx = -1;
      for (var ai = 0; ai < opts.length; ai++) {
        if (opts[ai].className.indexOf('active') > -1) { activeIdx = ai; break; }
      }
      if (activeIdx > 0) {
        preselected = true;
      } else {
        opts[1].click();
        if (opts[1].className.indexOf('active') > -1) {
          preselected = true;
        } else {
          preselectTries++;
          if (preselectTries > 10) preselected = true;
        }
      }
    }
    opts.forEach(function (opt) {
      var label = opt.querySelector('.bundle-pack-label');
      if (!label) return;
      // Normalise "2-PACK" / "3-PACK" to "2 PACK" / "3 PACK" (match "1 PACK")
      if (/\d\s*-\s*PACK/i.test(label.textContent)) {
        label.textContent = label.textContent.replace(/(\d)\s*-\s*(PACK)/gi, '$1 $2');
      }
      var priceEl = opt.querySelector('.bundle-price .money');
      var compareEl = opt.querySelector('.bundle-compare-price .money');
      var packCount = parseInt((label.textContent.match(/\d+/) || ['1'])[0], 10);

      if (!label.closest('.bundle-label-col')) {
        var col = document.createElement('div'); col.className = 'bundle-label-col';
        var top = document.createElement('div'); top.className = 'bundle-label-top';
        label.parentNode.insertBefore(col, label);
        top.appendChild(label);
        col.appendChild(top);
        if (packCount > 1 && priceEl) {
          var price = money(priceEl);
          if (price) {
            var each = document.createElement('span');
            each.className = 'bundle-each';
            each.textContent = '$' + (price / packCount).toFixed(2).replace(/\.00$/, '') + ' each';
            top.appendChild(each);
          }
        }
        if (subs[packCount]) {
          var sub = document.createElement('div');
          sub.className = 'bundle-subtitle';
          sub.textContent = subs[packCount];
          col.appendChild(sub);
        }
      }

      var nativeBadge = opt.querySelector('.bundle-popular-badge:not(.bundle-best-badge)');
      if (nativeBadge && !/SAVE/i.test(nativeBadge.textContent)) {
        var s = Math.round(money(compareEl) - money(priceEl));
        if (s > 0) nativeBadge.textContent = nativeBadge.textContent.trim() + ' · SAVE $' + s;
      }
    });

    var last = opts[opts.length - 1];
    var lastHeader = last && last.querySelector('.bundle-option-header');
    if (lastHeader && !lastHeader.querySelector('.bundle-popular-badge')) {
      var save = Math.round(money(last.querySelector('.bundle-compare-price .money')) - money(last.querySelector('.bundle-price .money')));
      var b = document.createElement('span');
      b.className = 'bundle-popular-badge bundle-best-badge';
      b.textContent = save > 0 ? ('Best value · save $' + save) : 'Best value';
      lastHeader.appendChild(b);
    }

    document.querySelectorAll('.bundle-color-label').forEach(function (p) {
      p.childNodes.forEach(function (n) {
        if (n.nodeType === 3 && /Your Colou?rs?:/i.test(n.textContent)) {
          n.textContent = n.textContent.replace(/Your Colou?rs?:/i, 'Colour:');
        }
      });
    });
    document.querySelectorAll('.bundle-color-label [class*="selected-colors-text"]').forEach(function (el) {
      if (/Bags?\s*-/i.test(el.textContent)) {
        el.textContent = el.textContent.replace(/Reusable\s+\w+\s+Bag\s*-\s*/gi, '').replace(/Beeswax-Lined\s+(?:Organic\s+)?Cotton\s+Bread\s+Bags?\s*-\s*/gi, '').replace(/,\s*$/, '').trim();
      }
    });
  }
  var t;
  function run() { clearTimeout(t); t = setTimeout(enhance, 80); }
  document.addEventListener('DOMContentLoaded', run);
  run();
  new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
})();

/* ---- Block 7: cart drawer upsell — send bundles to their product page ----
   The Section Store cart's "You may also like" +Add can't quick-add Fast
   Bundle products (they need component selection on their page), failing
   with "Please select all variants correctly". Intercept +Add clicks in
   the cart block (document-level capture sees through the open shadow
   root via composedPath); if the clicked product is a Bundle (type
   "Bundle" / tag "bundle"), navigate to its product page instead;
   otherwise re-dispatch the click so the normal quick-add proceeds. */
(function () {
  var passthrough = false;
  document.addEventListener('click', function (e) {
    if (passthrough) return;
    var path = e.composedPath ? e.composedPath() : [];
    var inCart = path.some(function (el) { return el && el.tagName === 'SECTION-STORE--CART-BLOCK'; });
    if (!inCart) return;
    var btn = null;
    for (var i = 0; i < path.length; i++) {
      var el = path[i];
      if (el && el.tagName === 'SECTION-STORE--CART-BLOCK') break;
      if (el && el.tagName === 'BUTTON' && /^\+?\s*add$/i.test((el.textContent || '').trim())) { btn = el; break; }
    }
    if (!btn) return;
    var title = null;
    for (var j = path.indexOf(btn) + 1; j < path.length; j++) {
      var anc = path[j];
      if (!anc || !anc.textContent || anc.tagName === 'SECTION-STORE--CART-BLOCK') break;
      var txt = anc.textContent.replace(/\s+/g, ' ').trim();
      if (txt.length > 5 && txt.length < 300 && txt.indexOf('$') > -1) {
        title = txt.split('$')[0].replace(/\+?\s*Add\s*$/i, '').trim();
        break;
      }
    }
    if (!title) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fetch('/search/suggest.json?q=' + encodeURIComponent(title) + '&resources[type]=product&resources[limit]=3')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var prod = s && s.resources && s.resources.results && s.resources.results.products && s.resources.results.products[0];
        if (!prod) throw new Error('no match');
        return fetch('/products/' + prod.handle + '.js').then(function (r) { return r.json(); });
      })
      .then(function (full) {
        if (full && (String(full.type).toLowerCase() === 'bundle' || (full.tags || []).indexOf('bundle') > -1)) {
          window.location.href = '/products/' + full.handle;
        } else {
          passthrough = true;
          btn.click();
          passthrough = false;
        }
      })
      .catch(function () {
        passthrough = true;
        btn.click();
        passthrough = false;
      });
  }, true);
})();

/* ---- Block 8: reward bar inside the Section Store drawer (v3) ----
   Two milestones on one track, measured on cart.total_price from /cart.js
   (AFTER discounts, cache bypassed) so it agrees exactly with both real
   rewards: $80 free gift (auto-added by Block 10) and $140 free shipping
   (Shopify rate). Confetti cannon fires from a milestone the moment it
   unlocks (upward crossings only — no confetti on plain page loads).
   Amounts formatted without trailing ".00" so Block 2b never rewrites
   them. Reacts to drawer re-renders via MutationObserver with a slow
   interval as fallback; bar starts hidden until the cart state is known. */
(function () {
  var GIFT_AT = 8000;  // $80 in cents — keep in sync with Block 10
  var SHIP_AT = 14000; // $140 in cents — keep in sync with the Shopify shipping rate
  var GIFT_PCT = (GIFT_AT / SHIP_AT * 100).toFixed(2) + '%';
  var TRUCK = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 3h15v13H1z"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';
  var GIFTSVG = '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';
  var applying = false;
  var prevTotal = null;
  var observedBodies = new WeakSet();
  function fmt(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }
  function host() {
    var ss = document.querySelector('section-store--cart-block');
    return ss && ss.shadowRoot ? ss.shadowRoot : null;
  }
  function ensureBar(root) {
    var bar = root.getElementById('t4e-drawer-ship-bar');
    if (bar) return bar;
    var body = root.querySelector('.cart-body');
    if (!body) return null;
    bar = document.createElement('div');
    bar.id = 't4e-drawer-ship-bar';
    bar.style.cssText = 'padding:14px 16px 6px;display:none;position:relative;';
    bar.innerHTML =
      '<div data-msg style="text-align:center;font-size:14px;color:#1f2a44;margin-bottom:12px;"></div>' +
      '<div style="position:relative;margin-right:14px;">' +
        '<div style="height:6px;background:#e6e6e6;border-radius:4px;overflow:hidden;">' +
          '<div data-fill style="height:100%;width:0%;background:#F27B26;border-radius:4px;transition:width .4s;"></div>' +
        '</div>' +
        '<div data-gift-badge style="position:absolute;left:' + GIFT_PCT + ';top:50%;transform:translate(-50%,-50%);width:26px;height:26px;border-radius:50%;background:#c7c7c7;display:flex;align-items:center;justify-content:center;transition:background .3s;">' + GIFTSVG + '</div>' +
        '<div data-badge style="position:absolute;right:-13px;top:50%;transform:translateY(-50%);width:26px;height:26px;border-radius:50%;background:#c7c7c7;display:flex;align-items:center;justify-content:center;transition:background .3s;">' + TRUCK + '</div>' +
      '</div>' +
      '<div style="position:relative;height:15px;margin-top:10px;padding-bottom:8px;margin-right:14px;">' +
        '<div data-gift-label style="position:absolute;left:' + GIFT_PCT + ';transform:translateX(-50%);font-size:11px;color:#1f2a44;white-space:nowrap;">Free gift</div>' +
        '<div data-label style="position:absolute;right:-14px;font-size:11px;color:#1f2a44;white-space:nowrap;">Free shipping</div>' +
      '</div>';
    body.insertBefore(bar, body.firstChild);
    return bar;
  }
  function confetti(bar, xFrac) {
    var cv = document.createElement('canvas');
    cv.width = 600; cv.height = 340;
    cv.style.cssText = 'position:absolute;left:0;bottom:-6px;width:100%;height:auto;pointer-events:none;z-index:9;';
    bar.appendChild(cv);
    var ctx = cv.getContext('2d');
    var W = cv.width, H = cv.height;
    var COLS = ['#F27B26', '#202F42', '#FFD166', '#6BBF59', '#E96479'];
    var parts = [];
    for (var i = 0; i < 80; i++) {
      var a = -Math.PI / 2 + (Math.random() - 0.5) * 1.3;
      var v = 5 + Math.random() * 8;
      parts.push({ x: W * xFrac, y: H * 0.8, vx: Math.cos(a) * v, vy: Math.sin(a) * v, rot: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.35, w: 5 + Math.random() * 5, h: 3 + Math.random() * 3, c: COLS[i % COLS.length], life: 60 + Math.random() * 35 });
    }
    function tick() {
      ctx.clearRect(0, 0, W, H);
      var alive = false;
      for (var j = 0; j < parts.length; j++) {
        var p = parts[j];
        if (p.life <= 0) continue;
        alive = true;
        p.life--; p.x += p.vx; p.y += p.vy; p.vy += 0.22; p.vx *= 0.99; p.rot += p.vr;
        ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.rot);
        ctx.globalAlpha = Math.max(0, Math.min(1, p.life / 25));
        ctx.fillStyle = p.c; ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
        ctx.restore();
      }
      if (alive) { requestAnimationFrame(tick); } else if (cv.parentNode) { cv.parentNode.removeChild(cv); }
    }
    requestAnimationFrame(tick);
  }
  function watch(root) {
    var body = root.querySelector('.cart-body');
    if (body && !observedBodies.has(body)) {
      observedBodies.add(body);
      new MutationObserver(function () { if (!applying) schedule(); }).observe(body, { childList: true, subtree: true });
    }
  }
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(refresh, 250); }
  function refresh() {
    var root = host();
    if (!root) return;
    watch(root);
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      var root2 = host();
      if (!root2) return;
      var bar = ensureBar(root2);
      if (!bar) return;
      applying = true;
      if (!cart.item_count) {
        if (bar.style.display !== 'none') bar.style.display = 'none';
        prevTotal = 0;
      } else {
        if (bar.style.display !== 'block') bar.style.display = 'block';
        var total = cart.total_price;
        var pct = Math.min(100, Math.round(total / SHIP_AT * 100));
        var msg;
        if (total < GIFT_AT) {
          msg = 'Add <b>' + fmt(GIFT_AT - total) + '</b> to unlock a <b>Free gift</b>.';
        } else if (total < SHIP_AT) {
          msg = 'Free gift unlocked! Add <b>' + fmt(SHIP_AT - total) + '</b> to unlock <b>Free shipping</b>.';
        } else {
          msg = 'All rewards unlocked!';
        }
        var msgEl = bar.querySelector('[data-msg]');
        if (msgEl.innerHTML !== msg) msgEl.innerHTML = msg;
        var fillEl = bar.querySelector('[data-fill]');
        var w = pct + '%';
        if (fillEl.style.width !== w) fillEl.style.width = w;
        var gb = bar.querySelector('[data-gift-badge]');
        if (gb) gb.style.background = total >= GIFT_AT ? '#F27B26' : '#c7c7c7';
        var sb = bar.querySelector('[data-badge]');
        if (sb) sb.style.background = total >= SHIP_AT ? '#F27B26' : '#c7c7c7';
        var gl = bar.querySelector('[data-gift-label]');
        if (gl) gl.style.color = total >= GIFT_AT ? '#F27B26' : '#1f2a44';
        var sl = bar.querySelector('[data-label]');
        if (sl) sl.style.color = total >= SHIP_AT ? '#F27B26' : '#1f2a44';
        if (prevTotal !== null) {
          if (prevTotal < GIFT_AT && total >= GIFT_AT) confetti(bar, GIFT_AT / SHIP_AT);
          if (prevTotal < SHIP_AT && total >= SHIP_AT) confetti(bar, 0.97);
        }
        prevTotal = total;
      }
      setTimeout(function () { applying = false; }, 100);
    }).catch(function () { applying = false; });
  }
  setInterval(function () { if (host()) refresh(); }, 4000);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(refresh, 1500); });
  } else {
    setTimeout(refresh, 1500);
  }
})();

/* ---- Block 10: auto-add the FREE GIFT product over $80 (v4) ----
   Uses the hidden $0 product "Free Gift" (product 9003908497579, variant
   47844868063403, type "free-gift" — NEVER type "add-on": SellUp blocks
   direct cart-adds of that type). NO discount involved — a BXGY/product
   discount can't combine with the multi-buy "Discount for 2/3" pricing, so
   the gift is simply a $0 product this block adds/removes by threshold.
   Rules (v4 — polices EVERY line of the gift variant, however it got there;
   it's a $0 product so there is no "shopper's own bag" to protect):
   - Eligible total (excludes the gift itself, add-ons, wholesale) ≥ $80
     → exactly ONE gift line at quantity 1 (extra lines / quantities are
     collapsed via /cart/update.js). Under $80 → every gift line removed.
   - Our own removal clears the "added" memory so the gift returns when the
     cart climbs back over; only a SHOPPER deleting it while still eligible
     counts as "no thanks" for the rest of the session.
   - The +/− quantity stepper is hidden on the gift line inside the Section
     Store drawer (shadow DOM: .cart-line-item > .cart-line-quantity) so
     shoppers can't bump it.
   - Session memory via try/catch helpers with in-memory fallback (iOS
     Safari storage restrictions). Gives up after 3 failed adds per load. */
(function () {
  var GIFT_VARIANT = 47844868063403;
  var THRESHOLD = 8000; // $80 in cents — keep in sync with Block 8's GIFT_AT
  var busy = false;
  var failures = 0;
  var giftTitle = null;
  var mem = {};
  function sget(k) { try { var v = sessionStorage.getItem(k); if (v !== null) return v; } catch (e) {} return mem[k] || null; }
  function sset(k, v) { mem[k] = v; try { sessionStorage.setItem(k, v); } catch (e) {} }
  function sdel(k) { delete mem[k]; try { sessionStorage.removeItem(k); } catch (e) {} }
  function giftLines(cart) {
    return cart.items.filter(function (it) { return it.variant_id === GIFT_VARIANT; });
  }
  function eligibleTotal(cart) {
    var sum = 0;
    cart.items.forEach(function (it) {
      if (it.variant_id === GIFT_VARIANT) return;
      if ((it.product_type || '').toLowerCase() === 'add-on') return;
      if (/wholesale/i.test(it.product_title || it.title || '')) return;
      sum += it.final_line_price;
    });
    return sum;
  }
  function post(url, body, done) {
    busy = true;
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { busy = false; if (done) done(r); })
      .catch(function () { busy = false; });
  }
  function check() {
    if (busy) return;
    fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      var lines = giftLines(cart);
      var total = eligibleTotal(cart);
      if (lines.length) giftTitle = lines[0].product_title || giftTitle;
      if (lines.length && total < THRESHOLD) {
        var offs = {};
        lines.forEach(function (l) { offs[l.key] = 0; });
        post('/cart/update.js', { updates: offs }, function () { sdel('t4e-gift-added'); });
        return;
      }
      if (lines.length) {
        var keep = null;
        for (var i = 0; i < lines.length; i++) { if (lines[i].properties && lines[i].properties._t4e_free_gift) { keep = lines[i]; break; } }
        if (!keep) keep = lines[0];
        var ups = {}, need = false;
        lines.forEach(function (l) {
          var q = (l === keep) ? 1 : 0;
          if (l.quantity !== q) { ups[l.key] = q; need = true; }
        });
        if (need) post('/cart/update.js', { updates: ups });
        sset('t4e-gift-added', '1');
        return;
      }
      if (sget('t4e-gift-added') && total >= THRESHOLD) {
        // gift was in the cart, cart is still eligible, gift is gone → the shopper removed it
        sset('t4e-gift-dismissed', '1');
        sdel('t4e-gift-added');
      }
      if (total >= THRESHOLD && !sget('t4e-gift-dismissed') && failures < 3) {
        post('/cart/add.js', { id: GIFT_VARIANT, quantity: 1, properties: { _t4e_free_gift: '1' } }, function (r) {
          if (r && r.ok) { sset('t4e-gift-added', '1'); } else { failures++; }
        });
      }
    }).catch(function () {});
  }
  // Hide the quantity stepper on the gift line inside the Section Store drawer
  function hideGiftStepper() {
    var ss = document.querySelector('section-store--cart-block');
    var root = ss && ss.shadowRoot;
    if (!root) return;
    var titleRe = giftTitle ? new RegExp(giftTitle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'i') : /free gift/i;
    root.querySelectorAll('.cart-line-item').forEach(function (line) {
      if (!titleRe.test(line.textContent || '')) return;
      var q = line.querySelector('.cart-line-quantity');
      if (q && q.style.display !== 'none') q.style.display = 'none';
    });
  }
  var observed = false;
  function watchDrawer() {
    var ss = document.querySelector('section-store--cart-block');
    var root = ss && ss.shadowRoot;
    if (!root || observed) return;
    observed = true;
    new MutationObserver(function () { setTimeout(hideGiftStepper, 50); }).observe(root, { childList: true, subtree: true });
    hideGiftStepper();
  }
  setInterval(function () { check(); watchDrawer(); hideGiftStepper(); }, 4000);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(function () { check(); watchDrawer(); }, 2500); });
  } else {
    setTimeout(function () { check(); watchDrawer(); }, 2500);
  }
})();
